<div class="box">
  <div class="page-header">
    <p class="page-title">Members</p>
    @if (edit) {
      <button mat-flat-button class="add-btn" (click)="openModal()">
        <mat-icon>person_add</mat-icon>
        Add Member
      </button>
    }
  </div>

  <div class="table-toolbar">
    <mat-form-field class="search-field">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput (keyup)="applyFilter($event)" placeholder="Search members…" />
    </mat-form-field>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="memberEmail">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
        <td mat-cell *matCellDef="let element">{{ element.memberEmail }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          @if (edit) {
            <button mat-icon-button class="action-btn action-btn--danger" title="Remove Member"
                    (click)="onDelete(element.memberEmail, element.groupName); $event.stopPropagation()">
              <mat-icon>person_remove</mat-icon>
            </button>
          }
        </td>
      </ng-container>

      <tr *matNoDataRow>
        <td colspan="2">
          @if (loading) {
            <div class="empty-state">
              <app-loading-spinner></app-loading-spinner>
            </div>
          } @else {
            <div class="empty-state">
              <mat-icon>group_off</mat-icon>
              <p>No members found</p>
            </div>
          }
        </td>
      </tr>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="table-row"></tr>
    </table>
  </div>

  <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons aria-label="Select page">
  </mat-paginator>
</div>
